import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AccessibilityWidget from './components/AccessibilityWidget';
import Home from './pages/Home';
import About from './pages/About';
import MensRehab from './pages/MensRehab';
import OrphanageMinistry from './pages/OrphanageMinistry';
import MinistryNeedy from './pages/MinistryNeedy';
import MinistryHomeless from './pages/MinistryHomeless';
import MinistryInfectious from './pages/MinistryInfectious';
import MinistryRefugees from './pages/MinistryRefugees';
import Testimonies from './pages/Testimonies';
import TestimonyDetail from './pages/TestimonyDetail';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Donate from './pages/Donate';

function App() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/mens-rehabilitation-center" element={<MensRehab />} />
          <Route path="/orphanage-ministry" element={<OrphanageMinistry />} />
          <Route path="/ministry-for-needy" element={<MinistryNeedy />} />
          <Route path="/ministry-for-homeless-people" element={<MinistryHomeless />} />
          <Route path="/ministry-for-people-with-acute-infectious-diseases" element={<MinistryInfectious />} />
          <Route path="/ministry-for-refugees" element={<MinistryRefugees />} />
          <Route path="/testimonies" element={<Testimonies />} />
          <Route path="/testimony/:slug" element={<TestimonyDetail />} />
          <Route path="/category/testimony" element={<Testimonies />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/donate" element={<Donate />} />
        </Routes>
      </main>
      <Footer />
      <AccessibilityWidget />
    </>
  );
}

export default App;
